import { createClient } from "@supabase/supabase-js"

const supabaseURL = import.meta.env.VITE_SUPABASE_URL!
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY!

// Validate environment variables
if (!supabaseURL || !supabaseAnonKey) {
  console.error("Missing Supabase environment variables. Please check your .env file.")
}

// Every function called through this client checks the caller's session, so a 401 means it's gone.
// The public ones - login, magic link, start-application - are called with plain fetch and never get here.
const isEdgeFunction = (url: string) =>
  new URL(url, window.location.origin).pathname.startsWith("/functions/v1/")

const fetchWithLoginRedirect: typeof fetch = async (input, init) => {
  const response = await fetch(input, init)
  const url = input instanceof Request ? input.url : input.toString()
  if (response.status === 401 && isEdgeFunction(url) && window.location.pathname !== "/login") {
    await supabase.auth.signOut({ scope: "local" })
    window.location.assign("/login")
  }
  return response
}

// Create Supabase client
const supabase = createClient(supabaseURL, supabaseAnonKey, {
  global: { fetch: fetchWithLoginRedirect },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: localStorage,
  },
})

export default supabase
